/**
 * Passing score for a lesson. Lesson grading and course completion both read
 * this one value. It equals the server's authoritative threshold, `PASS_THRESHOLD`
 * in packages/core-rust/src/grading.rs, so the client never disagrees with the
 * score the server writes.
 */
export const LESSON_PASS_THRESHOLD = 0.6;
